export const DEBOUNCE_TIME_TO_VIEW_PRODUCTS = 1000;

export const NOTIFICATIONS_FOR_PURCHASE_INCREMENT = 2;

export const ADDED_FROM_APP = 'Agregado desde app';
